import styled from 'styled-components';
import { FormHelpMixin } from '../../mixins/components/FormHelpMixin';
export var StyledFormHelp = /*#__PURE__*/styled.p.withConfig({
  displayName: "StyledFormHelp",
  componentId: "c11n-8-107-0__sc-1rkt9zk-0"
})(["", ""], FormHelpMixin);